import Optional from './Optional';
import StaticSingleton from './StaticSingleton';

export class LocalStorageKey extends StaticSingleton<LocalStorageKey> {
    private _keyName: string;
    
    private _onUpdate: (key: LocalStorageKey) => void;

    public Get = () => new Optional<string>(
        localStorage.getItem(this._keyName)!
    );

    public Set = (newValue: string): Optional<string> => {
        localStorage.setItem(this._keyName, String(newValue));
        
        if (this.Get().value === newValue) {
            return this.Get();
        }
        
        if (this._onUpdate) {
            this._onUpdate(this);
        }
        
        return this.Get();
    }

    constructor(keyName: string, defaultValue: string) {
        super();
        this._keyName = keyName;
        this.Get()
            .WhenEmpty(() => this.Get().value = defaultValue);
    }
    
    public Toggle = (): LocalStorageKey => {
        this.Get()
            .When(item => item !== 'true' && item !== 'false')
            .Then(() => {
                throw new Error(`The key ${this._keyName} cannot be toggled as it is not true or false`);
            });

        const newValue = String(!(this.Get().value === 'true'));
        this.Set(newValue);
        return this;
    }

    public OnUpdate(action: (key: LocalStorageKey) => void) {
        this._onUpdate = action;
        return this;
    }

    public Decide(whenTrue: Function, whenFalse: Function) {
        this.Get()
            .When(value => value === 'true')
            .Then(whenTrue);
        this.Get()
            .When(value => value === 'false')
            .Then(whenFalse);

        return this;
    }
}

export default function (keyName: string, defaultValue: string): LocalStorageKey {
    return new LocalStorageKey(keyName, defaultValue);
}